"use client"

import MsgDeskSurfaceClient from '../host/MsgDeskSurfaceClient'
import type { DeskSurfaceClientProps } from '../host/surfaceDescriptor'
import { HackernewsRoutedPage } from './deskUi/HackernewsRoutedPage'
import { MsgDeskLoading } from './deskUi/MsgDeskLoading'

export default function HackernewsSurfaceClient(props: DeskSurfaceClientProps) {
  return <MsgDeskSurfaceClient {...props} RoutedPage={HackernewsRoutedPage} Loading={MsgDeskLoading} />
}
